import { WebAuth, parseHash } from 'auth0-js';
import _ from 'lodash';
import sessionStorageService from 'scripts/services/sessionstorage-service';

const auth0Config = _.get(window.globalSettings, 'vc.auth0');

export const availableActions = {
    authorize: 'authorize',
    register: 'register',
    logout: 'logout',
};

let webAuth = null;
const params = {
    responseType: 'token',
    audience: `https://${auth0Config.domain}/api/v2/`,
    redirectUri: auth0Config.redirectUrl,
};

const getURLwithoutQuery = (url) => {
    const { protocol, host, pathname } = url;
    return `${protocol}//${host}${pathname}`;
};

export const init = (cb) => {
    webAuth = new WebAuth({
        domain: auth0Config.domain,
        clientID: auth0Config.clientID,
    });
};

export const getUserInfo = async (token) => {
    return new Promise((resolve) => {
        if (!token) {
            return resolve(false);
        }
        webAuth.client.userInfo(token, (err, info) => {
            if (err) {
                return resolve(false);
            }
            return resolve(info);
        });
    });
};

export const checkSession = (cb) => {
    sessionStorageService.setItemRaw(
        'vc-auth-redirect',
        getURLwithoutQuery(window.location),
    );
    webAuth.checkSession(params, cb);
};

export const logout = (returnTo) => {
    webAuth.logout({
        returnTo,
        clientID: auth0Config.clientID,
    });
};

export const authorize = (active_tab = 'login') => {
    sessionStorageService.setItemRaw(
        'vc-auth-redirect',
        getURLwithoutQuery(window.location),
    );
    webAuth.authorize(Object.assign(params, { active_tab }));
};
